import type { LeadsSearchRequestDto, SearchDemoMode } from "../types/dto";

/**
 * Stamps the active demo marker onto a search request DTO.
 *
 * Returns the input unchanged **by reference** when no demo is running — the DTO feeds `useMemo` deps and
 * react-query keys, so identity stability matters. Correctness does not depend on it: `hashKey` and the
 * request body both go through `JSON.stringify`, which omits `undefined`-valued properties, so an explicit
 * `demoMode: undefined` would serialize identically.
 *
 * Temporary — delete with the demo feature.
 */
export const withDemoMode = <T extends LeadsSearchRequestDto>(dto: T, demoMode: SearchDemoMode | undefined): T =>
    demoMode ? { ...dto, demoMode } : dto;
